import { FC } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';
import {
  MenuForm,
  StartDateForm,
  EndDateForm,
} from 'page/CustomerPage/components/ContractForms';
import { OriginalMenu } from 'types/menu';

type Props = {
  formState: FormState<ContractFormFields>;
  isOpen: boolean;
  isButtonDisabled: boolean;
  startDate: string;
  endDate: string;
  uncontractedMenus: OriginalMenu[];
  register: UseFormRegister<ContractFormFields>;
  changeStartDate: (startDate: string) => void;
  changeEndDate: (endDate: string) => void;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModalView: FC<Props> = ({
  formState,
  isOpen,
  isButtonDisabled,
  startDate,
  endDate,
  uncontractedMenus,
  register,
  changeStartDate,
  changeEndDate,
  handleClose,
  handleClickGoConfirmation,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="2xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
    isCentered
  >
    <ModalOverlay />
    <ModalContent h="60vh" minH="750px">
      <ModalHeader p="40px 40px 0 40px">契約メニューの登録</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {/* メニューID */}
        <Box mt="40px">
          <MenuForm
            menus={uncontractedMenus}
            register={register}
            error={formState.errors.menuId}
          />
        </Box>
        {/* 契約開始日 */}
        <Box mt="40px">
          <StartDateForm
            initialDate={startDate}
            handleChangeDate={(date) => changeStartDate(date)}
          />
        </Box>
        {/* 契約終了日 */}
        <Box mt="40px">
          <EndDateForm
            initialDate={endDate}
            handleChangeDate={(date) => changeEndDate(date)}
          />
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <Button
          width="140px"
          colorScheme="blackAlpha"
          mr={3}
          onClick={handleClickGoConfirmation}
          isDisabled={isButtonDisabled}
        >
          確認
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
